import gql from 'graphql-tag';
import suggestionCandidateFragmentInAdder from '../fragments/suggestionCandidateInAdder';

export default gql`
  query missingPopular($tenantId: ID!, $suggestionsListId: ID!) {
    missingPopular(
      tenant: $tenantId
      suggestionsListId: $suggestionsListId
      count: 50
    ) {
      id
      entries {
        ...suggestionCandidateInAdder
      }
    }
  }
  ${suggestionCandidateFragmentInAdder}
`;
